"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMentionStyle = exports.StyledFormControl = exports.floatingLabelClassName = exports.mentionInputClassName = void 0;

const material_1 = require("@mui/material");

exports.mentionInputClassName = "ssky-mention-input";
exports.floatingLabelClassName = "ssky-mention-input-floating-label";
const paddingTop = "21px";
const paddingBottom = "3px";
const padding = `${paddingTop} 0 ${paddingBottom} 0`;
const fontSize = 16;

const getPlaceholderStyle = isSuperscript => ({
  top: isSuperscript ? 0 : paddingTop,
  fontSize: isSuperscript ? 0.75 * fontSize : fontSize
});

exports.StyledFormControl = (0, material_1.styled)(material_1.FormControl, {
  shouldForwardProp: prop => prop !== "disabled" && prop !== "value"
})(({
  theme,
  error,
  disabled,
  value
}) => ({
  width: 200,
  [`& .${exports.mentionInputClassName}__control`]: {
    fontSize
  },
  [`& .${exports.mentionInputClassName}__input`]: {
    padding,
    border: 0,
    borderBottom: error ? `2px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    transition: theme.transitions.create("border-bottom-color", {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut
    }),
    "&:focus": {
      outline: "none",
      borderBottom: !error && `2px solid ${theme.palette.primary.main}`
    },
    "&:disabled": {
      color: theme.palette.text.disabled,
      borderBottom: !error && `1px dotted ${theme.palette.divider}`
    },
    "&:hover:not(:disabled):not(:focus)": {
      borderBottom: !error && `2px solid ${theme.palette.divider}`
    }
  },
  [`& .${exports.mentionInputClassName}__highlighter`]: {
    padding
  },
  [`& .${exports.mentionInputClassName}__suggestions`]: {
    backgroundColor: theme.palette.background.paper,
    marginTop: `calc(${paddingTop} + ${paddingBottom}) !important`,
    border: `1px solid ${theme.palette.action.disabledBackground}`,
    boxShadow: `0 0 8px ${theme.palette.action.disabled}`,
    width: "max-content",
    maxHeight: 300,
    overflow: "auto"
  },
  [`& .${exports.mentionInputClassName}__suggestions__item`]: {
    display: "flex",
    alignItems: "center",
    height: 48,
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut
    })
  },
  [`& .${exports.mentionInputClassName}__suggestions__item--focused`]: {
    backgroundColor: theme.palette.action.selected
  },
  [`& .${exports.floatingLabelClassName}`]: Object.assign(Object.assign({}, getPlaceholderStyle(Boolean(value))), {
    color: error ? theme.palette.error.main : disabled ? theme.palette.text.disabled : theme.palette.text.secondary,
    fontWeight: "normal",
    position: "absolute",
    pointerEvents: "none",
    transition: theme.transitions.create("all", {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut
    })
  }),
  "&:focus-within": {
    [`& .${exports.floatingLabelClassName}`]: Object.assign(Object.assign({}, getPlaceholderStyle(true)), {
      color: !error && theme.palette.primary.main
    })
  }
}));
exports.defaultMentionStyle = {
  backgroundColor: "#00A9E0",
  opacity: 0.3,
  padding: "1px 0",
  marginLeft: -1,
  borderRadius: 3
};